import { render, staticRenderFns } from "./competing.vue?vue&type=template&id=4169e901&scoped=true&"
import script from "./competing.vue?vue&type=script&lang=js&"
export * from "./competing.vue?vue&type=script&lang=js&"
import style0 from "./competing.vue?vue&type=style&index=0&id=4169e901&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4169e901",
  null
  
)

export default component.exports